import MainDetail from "../components/deal-detail/main-deal-detail";


function DealDetail() {
    return(<div><MainDetail/></div>)
}

export default DealDetail;